import Project from '@client-shared/models/project.model.js'

import { getResponseData } from '../utils/get-response-data'

export const getCompanyProjects = async ({ axios, signal }) => {
  const response = await axios.get('company/projects', { signal })

  const data = getResponseData(response)

  if (!data) { return [] }

  return data.map(p => new Project(p))
}

export const getCompanyUsers = async ({ axios, signal }) => {
  const response = await axios.get('users', {
    params: { scope: 'company' },
    signal,
  })

  const data = getResponseData(response)

  if (!data) { return [] }

  return data
}

export const getUserProjects = async ({
  axios,
  userId,
  signal,
  purpose,
}) => {
  const params = {}

  if (purpose === 'notify') {
    params.for = 'notification'
  }

  const response = await axios.get(`company/users/${userId}/projects`, {
    params,
    signal,
  })

  const data = getResponseData(response)

  if (!data) { return [] }

  return data
}

export const getExternalProjectsCount = async ({ axios, userId, signal }) => {
  const response = await axios.get(`company/users/${userId}/external-projects-count`, { signal })

  const data = getResponseData(response)

  return data?.count ?? 0
}

export const setUserEnabled = async ({ axios, userId, enabled, signal }) => {
  const response = await axios.patch(`users/${userId}`, {
    op: 'update',
    path: 'enabled',
    value: { new: enabled },
  }, {
    params: { scope: 'company' },
    signal,
  })

  return getResponseData(response)
}

export const companyTakeOwnership = async ({ axios, project, signal }) => {
  const response = await axios.patch(`projects/${project._id}`, {
    op: 'execute',
    path: 'companyTakeOwnership',
    value: {},
  }, { signal })

  return new Project(getResponseData(response))
}

export const informOwners = async ({ axios, userId, subject, message, recipients, signal }) => {
  const response = await axios.post('company/mail-to-admins', {
    userId,
    subject,
    message,
    recipients,
  }, { signal })

  return getResponseData(response)
}
